<script setup lang="ts">
import CollectionTile from "@/components/CollectionTile.vue";
import LinkTile from "@/components/LinkTile.vue";
import StartpageSectionHeadline from "@/components/startpage/SectionHeadline.vue";
import type { Collection } from "@/services/fobizzToolsApi";

type Props = {
  collections: Collection[];
  withLinkTile: boolean;
};

defineProps<Props>();

const { t } = useI18n();
</script>

<template>
  <div>
    <StartpageSectionHeadline>{{
      t("startPage.headers.material")
    }}</StartpageSectionHeadline>
    <ul class="collections__grid">
      <li v-for="collection in collections" :key="collection.id">
        <CollectionTile :collection="collection" />
      </li>
      <li v-if="withLinkTile">
        <LinkTile
          :title="t('startPage.linkTile.title')"
          :link-name="t('startPage.linkTile.linkName')"
          :to="{
            name: 'gallery-index',
          }"
          icon="columns-gap"
        />
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.collections__grid {
  list-style-type: none;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: $spacer-3;

  @include media-breakpoint-only(lg) {
    > li:nth-child(3) {
      display: none;
    }
  }

  @include media-breakpoint-down(xl) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @include media-breakpoint-down(lg) {
    grid-template-columns: 1fr 1fr;
  }

  @include media-breakpoint-down(sm) {
    grid-template-columns: 1fr;
  }
}
</style>
